import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {RegistrationApiService} from "../../../rg/api/registration-api.service";
import {CoreApiService} from "../../../core/service/core-api.service";
import {ForgotPasswordRequestDto, RegistrationRequestOtpDto} from "../../../rg/types/registration.types";
import {AuthService} from "../../../core/service/auth.service";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {MessageHelper} from "../../../core/helper/message-helper";
import {AppMessageService} from "../../../core/service/app-message.service";
import {SettingsService} from "../../service/settings.service";


@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent extends CoreComponent {

  formGroup: FormGroup | undefined;

  constructor(
    protected settingService: SettingsService,
    protected router: Router,
    protected registrationApiService: RegistrationApiService,
    protected formBuilder: FormBuilder,
    protected authService: AuthService,
    protected userApiService: UserApiService,
    protected messageService: AppMessageService,
    protected coreApiService: CoreApiService,
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.settingService.setHeader('Passwort ändern', 'Hier kannst du dein Passwort ändern.');
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.buildFormGroup();
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  handleStepComplete() {
    // this.onStepComplete.emit(3);
  }

  buildFormGroup() {
    this.formGroup = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    })
  }

  handleCheckPassword() {
    if (this.formGroup) {
      const password = this.formGroup.get('newPassword')?.value;
      const dto: RegistrationRequestOtpDto = {
        deviceInfo: this.coreApiService.getDeviceInfo(),
        password: password as string,
      }
      const samePassword = this.checkIfSamePassword();

      if (samePassword) {
        return;
      }


      if (password) {
        this.registrationApiService.checkPassword(dto).subscribe(res => {
          if (res.success == false) {
            this.formGroup?.get('newPassword')?.setErrors({invalidPassword: res.data});
          } else {
            this.formGroup?.get('newPassword')?.setErrors(null);
          }
          this.handlePasswordMatch();
        }, error => {
        })
      }
    }
  }

  checkIfSamePassword(): boolean {
    if (this.formGroup) {
      const oldPassword = this.formGroup.get('oldPassword')?.value;
      const newPassword = this.formGroup.get('newPassword')?.value;

      if (oldPassword === newPassword) {
        this.formGroup?.get('newPassword')?.setErrors({invalidPassword: 'Das neue Passwort darf nicht dasselbe wie das alte Passwort sein.'});
        return true;
      }
    }
    return false;

  }

  handlePasswordMatch() {
    if (this.formGroup) {
      const password = this.formGroup.get('newPassword')?.value;
      const confirmPassword = this.formGroup.get('confirmPassword')?.value;

      if (!confirmPassword || password != confirmPassword) {
        this.formGroup.get('confirmPassword')?.setErrors({
          passwordError: "Passwörter stimmen nicht überein!"
        });
      } else {
        this.formGroup.get('confirmPassword')?.setErrors(null);
      }
    }
  }

  handleChangePassword() {
    if (this.formGroup) {

      const oldPassword = this.formGroup.get('oldPassword')?.value;
      const newPassword = this.formGroup.get('newPassword')?.value;
      this.busy = true;

      this.authService.changePassword(oldPassword, newPassword).subscribe(res => {
        MessageHelper.showSuccessMessage(res.data as string, this.messageService);
        this.formGroup?.reset();
        this.router.navigate(['ds/us/profile']);
        this.busy = false;
      }, error => {
        MessageHelper.showErrorMessage(error.error.data, this.messageService);
        this.busy = false;
      })


    }
  }


}
